/* FEYRE custom sizing: reliable size switching across Kalles rerenders. */
(function(){
'use strict';
if(window.__FEYRE_CUSTOM_SIZE_V3__)return;
window.__FEYRE_CUSTOM_SIZE_V3__=true;
const sessions=new Map(), instances=new WeakMap(), styles=new Set();
function css(url){
 if(!url||styles.has(url))return;
 styles.add(url);
 if(Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(x=>x.href===url))return;
 const el=document.createElement('link');el.rel='stylesheet';el.href=url;el.dataset.feyreCustomStyles='true';document.head.appendChild(el);
}
function init(root){
 if(instances.has(root))return instances.get(root);
 const formId=root.dataset.feyreFormId;
 if(!formId)return null;
 const currentForm=()=>document.getElementById(formId);
 const key=formId;
 let s=sessions.get(key);
 if(!s){s={open:false,unit:'in',values:{},confirmed:false};sessions.set(key,s);}
 const fields=()=>Array.from(root.querySelectorAll('[data-feyre-input]'));
 const picker=()=>root.closest('.hdt-product-info__list')?.querySelector('hdt-variant-picker');
 const panel=()=>root.querySelector('[data-feyre-panel]');
 function mark(key){
  const f=fields().find(x=>x.dataset.feyreInput===key);if(!f)return;
  root.querySelectorAll('[data-feyre-marker]').forEach(x=>x.classList.toggle('is-active',x.dataset.feyreMarker===key));
  root.querySelectorAll('[data-feyre-field]').forEach(x=>x.classList.toggle('is-active',x.dataset.feyreField===key));
  const a=root.querySelector('[data-feyre-current-label]'),b=root.querySelector('[data-feyre-current-tip]'),c=root.querySelector('[data-feyre-svg-caption]');
  if(a)a.textContent=f.dataset.feyreLabel;
  if(b)b.textContent=f.dataset.feyreTip;
  if(c)c.textContent=f.dataset.feyreLabel.toUpperCase();
 }
 function paint(){
  const on=s.open,p=panel();
  if(p)p.hidden=!on;
  const entry=root.querySelector('[data-feyre-entry]');
  if(entry)entry.setAttribute('aria-expanded',String(on));
  fields().forEach(f=>{
   const k=f.dataset.feyreInput;
   if(f.dataset.feyreRestored!=='1'){
    if(Object.prototype.hasOwnProperty.call(s.values,k))f.value=s.values[k];
    f.dataset.feyreRestored='1';
   }
   f.disabled=!on;f.required=on;f.setCustomValidity('');
  });
  const confirm=root.querySelector('[data-feyre-confirm]');
  if(confirm){
   if(confirm.dataset.feyreRestored!=='1'){confirm.checked=s.confirmed;confirm.dataset.feyreRestored='1';}
   confirm.disabled=!on;confirm.required=on;
  }
  const sizing=root.querySelector('[data-feyre-property]');
  if(sizing)sizing.disabled=!on;
  const units=root.querySelector('[data-feyre-unit-property]');
  if(units){units.disabled=!on;units.value=s.unit==='cm'?'centimeters':'inches';}
  root.querySelectorAll('[data-feyre-suffix]').forEach(x=>x.textContent=s.unit==='cm'?'cm':'in');
  root.querySelectorAll('[data-feyre-unit]').forEach(x=>{
   x.classList.toggle('is-active',x.dataset.feyreUnit===s.unit);
   x.setAttribute('aria-pressed',String(x.dataset.feyreUnit===s.unit));
  });
  const sticky=document.querySelector('hdt-sticky-btn-atc');
  if(sticky){
   sticky.classList.toggle('feyre-sticky-custom-active',on);
   const priceBox=sticky.querySelector('.hdt-sticky-atc__variant-price');
   const select=priceBox?.querySelector('select.hdt-select');
   let summary=priceBox?.querySelector('.feyre-sticky-custom-summary');
   if(!on||!select){
    if(summary)summary.remove();
   }else{
    /* Shopify's option text already contains the formatted local price. */
    const optionText=select.selectedOptions?.[0]?.textContent?.trim()||'';
    const matched=optionText.match(/(?:Rs\.?\s*|PKR\s*|[$£€]\s*)[\d,.]+/i);
    const formatted=matched?.[0]||optionText.split(/\s[-–—]\s/).slice(1).join(' - ').trim();
    if(!summary){
     summary=document.createElement('span');
     summary.className='feyre-sticky-custom-summary';
     summary.setAttribute('aria-hidden','true');
     const sizeEl=document.createElement('span');
     sizeEl.className='feyre-sticky-custom-summary__size';
     sizeEl.textContent='Custom';
     const priceEl=document.createElement('span');
     priceEl.className='feyre-sticky-custom-summary__price';
     summary.append(sizeEl,priceEl);
     priceBox.appendChild(summary);
    }
    const priceEl=summary.querySelector('.feyre-sticky-custom-summary__price');
    if(priceEl)priceEl.textContent=formatted;
   }
  }
  const pk=picker();
  if(pk){
   pk.classList.toggle('feyre-has-custom',on);
   pk.querySelectorAll('[data-feyre-custom-select]').forEach(x=>{
    x.hidden=false;x.classList.toggle('is-active',on);x.setAttribute('aria-pressed',String(on));
   });
   const label=pk.querySelector('fieldset.is-style-size [update-value]');
   if(label){
    if(on){
     if(label.textContent.trim()!=='Custom'&&!label.dataset.feyreOld)label.dataset.feyreOld=label.textContent;
     if(label.textContent!=='Custom')label.textContent='Custom';
    }else if(label.textContent.trim()==='Custom'&&label.dataset.feyreOld){
     label.textContent=label.dataset.feyreOld;delete label.dataset.feyreOld;
    }
   }
  }
  if(on)mark('chest');
 }
 function open(){
  s.open=true;
  paint();
  css(root.dataset.feyreCssUrl);
  const p=panel();if(p)p.scrollIntoView({block:'nearest',behavior:'smooth'});
 }
 function close(){s.open=false;paint();}
 function changeUnits(next){
  if(next!==s.unit){
   const factor=next==='cm'?2.54:1/2.54;
   fields().forEach(f=>{
    if(f.value!==''&&Number.isFinite(Number(f.value))){
     f.value=String(Math.round(Number(f.value)*factor*10)/10);
     s.values[f.dataset.feyreInput]=f.value;
    }
   });
   s.unit=next;
  }
  paint();
 }
 function valid(){
  if(!s.open)return true;
  for(const f of fields()){
   const v=Number(f.value);
   if(f.value===''||!Number.isFinite(v)||v<=0||v>300){
    const msg=root.querySelector('[data-feyre-error]');if(msg)msg.hidden=false;
    f.setCustomValidity('Enter the finished garment measurement in '+s.unit+'.');
    f.focus();mark(f.dataset.feyreInput);f.reportValidity();
    panel()?.scrollIntoView({block:'nearest',behavior:'smooth'});
    return false;
   }
   f.setCustomValidity('');
  }
  const confirm=root.querySelector('[data-feyre-confirm]');
  if(confirm&&!confirm.checked){
   const msg=root.querySelector('[data-feyre-error]');if(msg)msg.hidden=false;
   confirm.focus();confirm.reportValidity();
   panel()?.scrollIntoView({block:'nearest',behavior:'smooth'});
   return false;
  }
  return true;
 }
 root.addEventListener('click',e=>{
  if(e.target.closest('[data-feyre-entry]')){e.preventDefault();s.open?close():open();return;}
  if(e.target.closest('[data-feyre-close]')){e.preventDefault();close();return;}
  const button=e.target.closest('[data-feyre-unit]');
  if(button){e.preventDefault();changeUnits(button.dataset.feyreUnit);}
 });
 root.addEventListener('input',e=>{
  const f=e.target.closest('[data-feyre-input]');if(!f)return;
  s.values[f.dataset.feyreInput]=f.value;f.setCustomValidity('');
  const msg=root.querySelector('[data-feyre-error]');if(msg)msg.hidden=true;
 });
 root.addEventListener('focusin',e=>{
  const f=e.target.closest('[data-feyre-input]');if(f)mark(f.dataset.feyreInput);
 });
 root.addEventListener('change',e=>{
  if(e.target.matches('[data-feyre-confirm]'))s.confirmed=e.target.checked;
 });

 const state={getForm:currentForm,root,open,close,paint,valid,isOpen:()=>s.open,unit:()=>s.unit};
 instances.set(root,state);
 if(s.open)css(root.dataset.feyreCssUrl);
 paint();
 return state;
}
function near(el){
 const root=el?.closest('.hdt-product-info__list')?.querySelector('[data-feyre-size]');
 return root?init(root):null;
}
function active(){
 for(const root of document.querySelectorAll('[data-feyre-size]')){
  const state=init(root);if(state?.isOpen())return state;
 }
 return null;
}
document.addEventListener('click',e=>{
 const custom=e.target.closest('[data-feyre-custom-select]');
 if(custom){
  const st=near(custom);if(!st)return;
  e.preventDefault();e.stopImmediatePropagation();
  st.isOpen()?st.close():st.open();return;
 }
 const standard=e.target.closest('fieldset.is-style-size label.hdt-product-form_value,fieldset.is-style-size input[type="radio"]');
 if(standard){const st=near(standard);if(st?.isOpen())st.close();}
 const sticky=e.target.closest('hdt-sticky-btn-atc button[type="submit"]');
 if(sticky){
  const st=active();if(!st)return;
  e.preventDefault();e.stopImmediatePropagation();
  if(!st.valid())return;
  const form=st.getForm();
  const submit=form?.querySelector('.hdt-product-form__submit[type="submit"]');
  if(form&&submit&&!submit.disabled)form.requestSubmit(submit);
 }
 const pay=e.target.closest('.shopify-payment-button');
 if(pay){const st=active();if(st&&!st.valid()){e.preventDefault();e.stopImmediatePropagation();}}
},true);
document.addEventListener('change',e=>{
 if(e.target.matches('fieldset.is-style-size input[type="radio"],hdt-sticky-btn-atc select[name="id"]')){
  const st=e.target.closest('hdt-sticky-btn-atc')?active():near(e.target);
  if(st?.isOpen())st.close();
 }
},true);

document.addEventListener('formdata',e=>{
 const id=e.target?.id;
 if(!id)return;
 for(const root of document.querySelectorAll('[data-feyre-size]')){
  if(root.dataset.feyreFormId!==id)continue;
  const state=init(root);
  if(!state?.isOpen())return;
  e.formData.set('properties[Sizing Method]','Custom Made to Measure');
  e.formData.set('properties[Measurement Unit]',state.unit()==='cm'?'centimeters':'inches');
  return;
 }
},true);
document.addEventListener('submit',e=>{
 if(e.target.closest('hdt-sticky-btn-atc')){
  const st=active();if(!st)return;
  e.preventDefault();e.stopImmediatePropagation();
  if(!st.valid())return;
  const form=st.getForm();
  const submit=form?.querySelector('.hdt-product-form__submit[type="submit"]');
  if(form&&submit&&!submit.disabled)form.requestSubmit(submit);
 }else{
  const st=near(e.target);
  if(st?.isOpen()&&!st.valid()){e.preventDefault();e.stopImmediatePropagation();}
 }
},true);
function scan(){
 document.querySelectorAll('[data-feyre-size]').forEach(root=>{
  const st=init(root);if(st?.isOpen())st.paint();
 });
}
function watch(){
 if(!window.MutationObserver||!document.body)return;
 let queued=false;
 new MutationObserver(records=>{
  if(queued)return;
  const relevant=records.some(r=>Array.from(r.addedNodes).some(n=>
   n.nodeType===1&&(
    n.matches?.('[data-feyre-size],hdt-variant-picker,.hdt-product-info__list') ||
    n.querySelector?.('[data-feyre-size],hdt-variant-picker,.hdt-product-info__list')
   )
  ));
  if(!relevant)return;
  queued=true;
  requestAnimationFrame(()=>{queued=false;scan();});
 }).observe(document.body,{subtree:true,childList:true});
}
function boot(){scan();watch();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',scan);
})();